export default "__VITE_ASSET__8ce419d0__"